module.exports = __webpack_public_path__ + "static/img/flower_2.2bdd4de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flower_2.png
// module id = kKys
// module chunks = 1